import { render } from "./contentsDetailView.vue?vue&type=template&id=712e1bae&scoped=true"
import script from "./contentsDetailView.vue?vue&type=script&lang=js"
export * from "./contentsDetailView.vue?vue&type=script&lang=js"

import "./contentsDetailView.vue?vue&type=style&index=0&id=712e1bae&lang=css"
import "./contentsDetailView.vue?vue&type=style&index=1&id=712e1bae&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712e1bae"]])

export default __exports__